<template>
  <div class="container">
    <el-row>
      <!--目录-->
      <el-col :span="3">
        <zg-catalog title="原始记录（直观）" :route-name="'site_'+this.site_type+'_list'"></zg-catalog>
      </el-col>
      <!--原始记录操作-->
      <el-col :span="21">
        <Toolbar
            :inspectStatus="inspect_status"
            :buttons="[
              {text:'新增', type: 'primary', onClick: handleAdd},
            ]"
            :currentRoute="currentRoute"
            :projectId="project_id"
            :siteId="site_id"
        />
        <hr>
        <!---列表-->
        <el-table :data="tableData" :header-cell-style="{background:'#B4DDD1',color:'#555'}"
                  style="width: 100%" @dblclick="handleEditImage">
          <el-table-column prop="id" label="序号"></el-table-column>
          <el-table-column prop="location" label="位置"></el-table-column>
          <el-table-column prop="item2_code" label="项目编号"></el-table-column>
          <el-table-column prop="item2_content" label="检测标准"></el-table-column>
          <el-table-column prop="item2_level" label="重要程度"></el-table-column>
          <el-table-column prop="trouble" label="隐患"></el-table-column>
          <el-table-column prop="url" label="图片">
            <template v-slot="scope">
              <img :src="scope.row.url" width="70" height="70" @click="previewPic(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <!--              <el-button v-if="inspect_status" size="mini" plain type="primary" @click="handleEditImage(scope.row)">-->
              <!--                编辑-->
              <!--              </el-button>-->
              <el-button v-if="inspect_status" size="mini" plain type="danger" @click="handleDel(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--图片列表分页-->
        <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
                       :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
      </el-col>
    </el-row>

    <!--新增-->
    <el-dialog title="新增" :visible.sync="form.show" width="800px">
      <el-form :model="form">
        <el-form-item>
          <el-input v-model="form.location" placeholder="请输入位置"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.item2_code" clearable filterable placeholder="请选择项目" @change="item2Change"
                     style="width: 100%">
            <el-option v-for="item in item2CodeOpts" :key="item.value" :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.trouble" clearable placeholder="请选择隐患" style="width: 100%">
            <el-option v-for="(item,index) in troubleOptions" :key="item.index"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-col :span="11">
            <el-upload action="https://dq-back.wzfire.com/upload_file"
                       name="upload_file"
                       ref="upload"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove"
                       :on-success="uploadSuccess"
                       :headers="headers"
                       accept=".jpeg,.jpg,.png"
                       :data="uploadData"
                       :limit="1"
                       :before-upload="beforeUpload"
                       :on-exceed="onExceed"
                       :on-change="handleEditChange"
                       :class="{hide:hideUpload}"
            >
              点击上传图片
            </el-upload>
          </el-col>
          <el-col :span="11">
            <el-input v-model="image_desc" placeholder="请在此添加图片的描述" disabled
                      style="margin-top:50px"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onAdd">提交</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--预览图片-->
    <el-dialog :visible.sync="pictureModel.dialogVisible" :modal="false" v-model="pictureModel" title="图片预览"
               width="50%">
      <img :src="pictureModel.previewpic" alt="" width="100%"/>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="pictureModel.dialogVisible = false">OK</el-button>
          </span>
    </el-dialog>
    <!--编辑图片描述-->
    <el-dialog :visible.sync="editPictureModel.show" title="编辑图片描述" width="50%">
      <el-form v-model="editPictureModel">
        <el-form-item label="描述">
          <el-input v-model="editPictureModel.pic_desc"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onEditImage">提交</el-button>
          <el-button type="info" @click="handleCloseEditImage">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--预览图片-->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

  </div>
</template>
<script>
import zg_opt from "@/modules/project/base/detail/record/config/zg_opt";
import Vue from "vue";
import Toolbar from "@/components/Toolbar.vue";

let token = Vue.$Config.userinfo.token
export default {
  components: {Toolbar},
  data() {
    return {
      headers: {Authorization: token},
      currentRoute: 'record_zg_index',
      hideUpload: false,
      uploadData: {
        project_id: '',
        site_id: '',
        site_type: '',
        zg_type: '',
      },
      project_id: '',
      site_id: '',
      site_type: '',
      zg_type: '',
      inspect_status: false,
      pages: [],
      currentPage: '',
      maxPage: 0,
      currentOpt: '',
      opts: zg_opt,
      items: [],
      //图片
      current_page: 1,
      pagination: {current_page: 1, total: 1, per_page: 10},
      tableData: [],
      form: {
        show: false,
        location: '',
        item2_code: '',
        trouble: '',
        image_id: '',
      },
      wzOpts: [],
      item2CodeOpts: [],
      item2TroubleOptions: [],
      troubleOptions: [],
      dialogVisible: false,
      dialogImageUrl: '',
      pictureModel: {
        dialogVisible: false,
        previewpic: '',
      },
      editPictureModel: {
        show: false,
        id: '',
        pic_desc: ''
      },
    }
  },
  computed: {
    image_desc: function () {
      return this.form.location + this.form.trouble
    }
  },
  methods: {
    async init() {
      this.project_id = this.$route.params.project_id
      this.site_id = this.$route.params.site_id
      this.site_type = this.$route.params.site_type
      this.zg_type = this.$route.params.zg_type
      this.uploadData.zg_type = this.$route.params.zg_type
      this.uploadData.project_id = this.$route.params.project_id
      this.uploadData.site_id = this.$route.params.site_id
      this.uploadData.site_type = this.$route.params.site_type
      await this.setButtonStatus()
      await this.getZgItems()
      await this.getList()
    },
    item2Change(val) {
      this.troubleOptions = []
      this.item2TroubleOptions[val].forEach(item => {
        this.troubleOptions.push({label: item, value: item})
      })
      this.$forceUpdate()
    },
    //新增
    handleAdd() {
      this.form.show = true;
    },
    async onAdd() {
      try {
        let params = this.form
        delete params.show
        params.project_id = this.project_id
        params.site_id = this.site_id
        params.site_type = this.site_type
        params.zg_type = this.zg_type
        await this.$Api.post('add_record_zg_09', params)
        this.onAddClose()
        this.$message.success('新增成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.form.show = false
      this.form.location = ''
      this.form.item2_code = ''
      this.form.trouble = ''
      this.form.image_desc = ''
      location.reload()
    },
    //编辑图片
    handleEditImage(row) {
      this.editPictureModel.show = true;
      this.editPictureModel.id = row.id
      this.editPictureModel.pic_desc = row.pic_desc
    },
    async onEditImage() {
      try {
        await this.$Api.post('edit_zg_image', {id: this.editPictureModel.id, pic_desc: this.editPictureModel.pic_desc})
        await this.getList()
        this.$message.success("修改成功")
        this.handleCloseEditImage()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleCloseEditImage() {
      this.editPictureModel.show = false
      this.editPictureModel.pic_desc = ''
      this.editPictureModel.id = ''
    },
    //删除图片
    async handleDel(row) {
      try {
        await this.$Api.post('del_zg_09', {id: row.id})
        await this.getList()
        this.$message.success("删除成功")
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //预览图片
    previewPic(row) {
      this.pictureModel.previewpic = row.url
      this.pictureModel.dialogVisible = true
    },
    //上传图片
    onExceed(files, fileList) {
      this.$message.error("只能上传一个图片")
    },
    beforeUpload(file) {
      if (this.form.location.length === 0 || this.form.item2_code.length === 0) {
        this.$message.error("请先选择位置和项目编号")
        return false
      }
    },
    uploadSuccess(response, file, fileList) {
      this.form.image_id = response.data.file_id
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.hideUpload = fileList.length >= 1
      try {
        this.$Api.post('del_upload_file', {id: file.response.data.file_id})
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    handleEditChange(file, fileList) {
      this.hideUpload = fileList.length >= 1
    },
    //图片列表
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    //获取检测项
    async getZgItems() {
      try {
        let res = await this.$Api.post('get_zg_items', {zg_type: this.zg_type, site_type: this.site_type})
        if (res) {
          this.items = res;
          this.items.item2s.forEach(item2 => {
            this.item2CodeOpts.push({label: item2.item2_content, value: item2.item2_code})
            this.item2TroubleOptions[item2.item2_code] = item2.trouble_options
          })
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },

    async getList() {
      try {
        let data = await this.$Api.post('index_record_zg_09', {
          project_id: this.project_id,
          site_id: this.site_id,
          form_page: this.currentPage,
          zg_type: this.zg_type,
          ...this.pagination
        })
        if (data) {
          this.pagination = {
            current_page: data.current_page,
            total: data.total,
            per_page: data.per_page
          }
          this.tableData = data.data;
        } else {
          this.tableData = []
          this.pagination = {current_page: 1, total: 1, per_page: 10}
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'zg'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },

    // 选择问题
    problemChange(item2_code) {
      this.items.item2s.some(v => {
        if (v.item2_code === item2_code) {
          this.locationForm.trouble_options = v.trouble_options
          return true;
        }
      });
    },

  },

  async created() {
    await this.init();
  },
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>

<style>
.hide .el-upload--picture-card {
  display: none;
}

.zg-max-select .el-select-dropdown__list {
  max-width: 700px;
}
</style>
